import {
  formatCountdown,
  parseCountdownDate,
  startCountdown,
} from '@lyle/countdown'

class LyleHeroBanner extends HTMLElement {
  #stopCountdowns = []
  #videoObserver

  connectedCallback() {
    this.#initCountdowns()
    this.#initVideo()
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.#loadVideo)
    this.#videoObserver?.disconnect()

    for (const stop of this.#stopCountdowns) {
      stop()
    }

    this.#stopCountdowns = []
  }

  #initCountdowns() {
    const containers = this.querySelectorAll(
      '[data-hero-banner-countdown-container]'
    )

    for (const container of containers) {
      this.#bindCountdown(container)
    }
  }

  #bindCountdown(container) {
    const countdownElement = container.querySelector(
      '[data-hero-banner-countdown]'
    )
    if (!countdownElement) return

    const endDate = parseCountdownDate(container.dataset.countdown)
    if (!endDate) return

    const stop = startCountdown(
      endDate,
      timeLeft => {
        container.dataset.countdownState = 'running'
        countdownElement.textContent = formatCountdown(timeLeft)
      },
      () => {
        container.dataset.countdownState = 'ended'
        countdownElement.textContent = formatCountdown(0)
      }
    )

    this.#stopCountdowns.push(stop)
  }

  #initVideo() {
    const video = this.querySelector('[data-hero-banner-video]')
    if (!video) return

    const loadAfterPage = () => {
      if (document.readyState === 'complete') {
        this.#loadVideo()
      } else {
        window.addEventListener('load', this.#loadVideo, { once: true })
      }
    }

    this.#videoObserver = new IntersectionObserver(
      entries => {
        if (!entries.some(({ isIntersecting }) => isIntersecting)) return

        this.#videoObserver.disconnect()
        loadAfterPage()
      },
      { rootMargin: '200px' }
    )

    this.#videoObserver.observe(video)
  }

  #loadVideo = () => {
    const video = this.querySelector('[data-hero-banner-video]')
    const sources = video?.querySelectorAll('source[data-src]')
    if (!sources?.length) return

    for (const source of sources) {
      source.src = source.dataset.src
      delete source.dataset.src
    }

    video.load()
    video.play().catch(() => {})
  }
}

if (!customElements.get('lyle-hero-banner')) {
  customElements.define('lyle-hero-banner', LyleHeroBanner)
}
